import { render, staticRenderFns } from "./ProductTranslationEditPopup.vue?vue&type=template&id=6dd315e9&"
import script from "./ProductTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./ProductTranslationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports